export const SUSPICIOUS_KEYWORDS = [
  'login',
  'verify',
  'wallet',
  'seed',
  'support',
  'giveaway',
  'reset',
  'oauth',
  'consent',
  'secure',
  'account',
  'update',
  'unlock',
  'signin',
  'bank',
  'payment'
] as const;
